import AwsLogo from "../assets/aws-logo.svg";
import GCPLogo from "../assets/gcp-logo.svg";
import AzureLogo from "../assets/azure-logo.svg";
import ExoscaleLogo from "../assets/exoscale-logo.svg";
import { CloudProvider } from "../types";

interface CloudIconProps {
    provider?: CloudProvider;
}

const CloudIcon = ({
    provider
}: CloudIconProps) => {

    return provider === "aws" || provider === "ecr" ? <img src={AwsLogo} style={{ width: "24px" }} alt="aws" /> :
        provider === "google" ? <img src={GCPLogo} style={{ width: "20px", height: "20px" }} alt="gcp" /> :
            provider === "azure" || provider === "azurerm" ? <img src={AzureLogo} style={{ width: "22px", height: "22px" }} alt="azure" /> :
                provider === "exoscale" ? <img src={ExoscaleLogo} style={{ width: "19px", height: "19px", marginTop: "-5px" }} alt="exoscale" /> :
                    undefined

}

export default CloudIcon;